import { render, staticRenderFns } from "./addUserToProject.vue?vue&type=template&id=ae97088e&scoped=true&"
import script from "./addUserToProject.vue?vue&type=script&lang=js&"
export * from "./addUserToProject.vue?vue&type=script&lang=js&"
import style0 from "./addUserToProject.vue?vue&type=style&index=0&id=ae97088e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae97088e",
  null
  
)

export default component.exports